import React, { HTMLProps } from 'react';
import classnames from 'classnames';
import modifiers from './modifiers';
interface IProps extends HTMLProps<HTMLElement> {
    id?: string;
    className?: string;
    renderAs?: string;
    domRef?: any;
    children?: React.ReactNode;
}

export default function Element({
    id,
    className,
    renderAs = 'div',
    domRef,
    children,
    ...rest
}: IProps) {
    const RenderAs = renderAs;
    const props = modifiers.clean(rest);

    return (
        <RenderAs
            ref={domRef}
            id={id}
            className={
                classnames(className, modifiers.classnames(rest)) || undefined
            }
            {...props}
        >
            {children}
        </RenderAs>
    );
}
